<template>
  <!-- `relative z-500` clears ProgressPills, whose empty flanks are an invisible z-250 overlay
       across the whole nav row. Both sit inside MerchantNav's backdrop-blur stacking context, so
       this is a local comparison and never competes with MerchantBasket's own z-500. -->
  <button
    type="button"
    data-testid="cart-pill"
    :aria-label="ariaLabel"
    class="relative z-500 hidden md:inline-flex items-center h-8 gap-1.5 px-3 text-sm font-semibold text-white rounded-full bg-brand-500 shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-800"
    @click="$emit('click')"
  >
    <ShoppingBagIcon class="flex-none w-4 h-4" />
    <span class="tabular-nums" data-testid="cart-pill-label">{{ label }}</span>
  </button>
</template>

<script>
import { ShoppingBagIcon } from '@heroicons/vue/solid'

// Desktop only. On a phone the sticky basket bar is already showing the same count and total a few
// centimetres below, and two cart affordances on one small screen read as clutter rather than
// convenience - so the pill hides below `md` and the bottom bar is the only cart entry point there.
export default {
  name: 'MerchantCartPill',

  components: { ShoppingBagIcon },

  props: {
    quantity: { type: Number, default: 0 },
    // Pre-formatted by whichever checkout mounted this - V1 reads the cart's `total_price.format`,
    // V2 the snapshot's `total_formatted.format`, and neither is a cents value the pill could
    // format itself without knowing the currency.
    total: { type: String, default: null },
    showPrice: { type: Boolean, default: true }
  },

  emits: ['click'],

  computed: {
    itemLabel() {
      return `${this.quantity} item${this.quantity === 1 ? '' : 's'}`
    },

    label() {
      if (!this.showPrice || !this.total) return this.itemLabel
      return `${this.itemLabel} · ${this.total}`
    },

    ariaLabel() {
      return `Cart: ${this.label}. Show cart`
    }
  }
}
</script>
